/** Inter-site : multi-site obligatoire + flag. Terrain : uniquement le flag (indépendant du multi-site). */

/** Aligné sur le serveur : TINYINT, bool, chaînes "0"/"1" (attention : Boolean("0") === true en JS brut). */
export function isEnterpriseModuleEnabled(value) {
  if (value === true || value === 1) return true;
  if (value === false || value === 0 || value == null) return false;
  if (typeof Buffer !== 'undefined' && Buffer.isBuffer?.(value)) {
    if (value.length === 0) return false;
    return value[value.length - 1] !== 0;
  }
  if (typeof value === 'string') {
    const s = value.trim().toLowerCase();
    if (s === '0' || s === 'false' || s === '') return false;
    if (s === '1' || s === 'true') return true;
  }
  return Boolean(value);
}

export function entrepriseHasMultiSites(entreprise) {
  if (!entreprise) return false;
  return isEnterpriseModuleEnabled(entreprise.multi_sites);
}

export function isInterSiteProspectionEnabled(entreprise) {
  return (
    entrepriseHasMultiSites(entreprise) &&
    isEnterpriseModuleEnabled(entreprise?.pointage_inter_site_enabled)
  );
}

export function isTerrainProspectionEnabled(entreprise) {
  return isEnterpriseModuleEnabled(entreprise?.pointage_terrain_enabled);
}
